package com.kinoshazam.uiKit.components.menuItem

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp


data class MenuItemState(
    val title: String? = null,
    val iconRes: String? = null,
    val iconPlaceholder: Painter? = null,
    val tintColor: Color? = null,
    val selectedTintColor: Color? = null,
    val animateIcon: Boolean = false,
    val isSelected: Boolean = false,
    val gap: Dp = 0.dp,
    val onAction: () -> Unit = {},
)
